import React from "react";

const MyReferalsIcon = ({ color = "#5D5D5D" }) => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.33332 7.49974C4.33332 8.38339 3.61698 9.09974 2.73332 9.09974C1.84966 9.09974 1.13332 8.38339 1.13332 7.49974C1.13332 6.61608 1.84966 5.89974 2.73332 5.89974C3.61698 5.89974 4.33332 6.61608 4.33332 7.49974ZM5.09399 8.74118C4.6474 9.58865 3.75783 10.1664 2.73332 10.1664C1.26056 10.1664 0.0666504 8.9725 0.0666504 7.49974C0.0666504 6.02697 1.26056 4.83307 2.73332 4.83307C3.75783 4.83307 4.6474 5.41082 5.09399 6.25828L8.71117 3.99753C8.63884 3.75537 8.59998 3.49876 8.59998 3.23307C8.59998 1.76032 9.7939 0.566406 11.2667 0.566406C12.7394 0.566406 13.9333 1.76032 13.9333 3.23307C13.9333 4.70583 12.7394 5.89974 11.2667 5.89974C10.4043 5.89974 9.63747 5.49036 9.15002 4.85533L5.3843 7.20891C5.39467 7.30442 5.39998 7.40146 5.39998 7.49974C5.39998 7.59801 5.39467 7.69504 5.3843 7.79056L9.15003 10.1441C9.63748 9.50912 10.4043 9.09974 11.2667 9.09974C12.7394 9.09974 13.9333 10.2936 13.9333 11.7664C13.9333 13.2391 12.7394 14.433 11.2667 14.433C9.7939 14.433 8.59998 13.2391 8.59998 11.7664C8.59998 11.5007 8.63884 11.2441 8.71118 11.0019L5.09399 8.74118ZM11.2667 4.83307C12.1503 4.83307 12.8667 4.11673 12.8667 3.23307C12.8667 2.34941 12.1503 1.63307 11.2667 1.63307C10.383 1.63307 9.66665 2.34941 9.66665 3.23307C9.66665 4.11673 10.383 4.83307 11.2667 4.83307ZM12.8667 11.7664C12.8667 12.6501 12.1503 13.3664 11.2667 13.3664C10.383 13.3664 9.66665 12.6501 9.66665 11.7664C9.66665 10.8827 10.383 10.1664 11.2667 10.1664C12.1503 10.1664 12.8667 10.8827 12.8667 11.7664Z"
        fill={color}
      />
    </svg>
  );
};

export default MyReferalsIcon;
